import { render, staticRenderFns } from "./SupportModal.vue?vue&type=template&id=507121b6&"
import script from "./SupportModal.vue?vue&type=script&lang=js&"
export * from "./SupportModal.vue?vue&type=script&lang=js&"
import style0 from "./SupportModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports